import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card card-flush" }
const _hoisted_2 = { class: "card-header border-bottom" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-body pt-8" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = {
  key: 0,
  class: "table table-hover table-rounded table-row-bordered table-striped align-middle gs-0 gy-3 my-2"
}
const _hoisted_8 = { class: "fs-7 fw-bold text-gray-500 border-bottom-1" }
const _hoisted_9 = { class: "p-0 pb-3 min-w-175px text-start" }
const _hoisted_10 = { class: "p-0 pb-3 min-w-100px text-center" }
const _hoisted_11 = { class: "p-0 pb-3 min-w-175px text-center" }
const _hoisted_12 = { class: "p-0 pb-3 w-145px text-end pe-7" }
const _hoisted_13 = { class: "ps-2" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_16 = {
  href: "#",
  class: "text-gray-800 fw-bold text-hover-primary mb-1 fs-6"
}
const _hoisted_17 = { class: "text-center pe-0" }
const _hoisted_18 = { class: "d-flex align-items-center flex-column mt-0 w-100" }
const _hoisted_19 = { class: "d-flex justify-content-between fw-bold fs-7 text-muted opacity-75 w-100 mt-auto mb-1" }
const _hoisted_20 = { class: "h-8px mx-3 w-100 bg-light bg-opacity-50 rounded" }
const _hoisted_21 = ["aria-valuenow"]
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = {
  key: 0,
  class: "text-end pe-2"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-clockwise fs-2 text-gray-700" }, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  class: "bi bi-check-circle fs-2 text-success"
}
const _hoisted_29 = {
  key: 1,
  class: "bi bi-clipboard-check fs-2 text-gray-700"
}
const _hoisted_30 = ["href"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-down fs-2 text-gray-700" }, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-linkedin fs-2 text-gray-700" }, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 1,
  class: "text-end pe-2"
}
const _hoisted_37 = /*#__PURE__*/_createStaticVNode("<span class=\"bg-body w-30px h-30px mx-2\"><i class=\"bi bi-clipboard-check fs-2 text-gray-400\"></i></span><span class=\"bg-body w-30px h-30px mx-2\"><i class=\"bi bi-file-earmark-arrow-down fs-2 text-gray-400\"></i></span><span class=\"bg-body w-30px h-30px mx-2\"><i class=\"bi bi-linkedin fs-2 text-gray-400\"></i></span>", 3)
const _hoisted_40 = [
  _hoisted_37
]
const _hoisted_41 = {
  key: 1,
  class: "py-6 d-flex justify-content-center text-center itens-center"
}
const _hoisted_42 = { class: "py-10" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border text-primary fs-7" }, null, -1)
const _hoisted_44 = { class: "text-muted fs-4 fw-bold mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountBase = _resolveComponent("AccountBase")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AccountBase),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.profile.certificate.certificate_course`)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_8, [
                      _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.course_caps`)), 1),
                      _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.progress_caps`)), 1),
                      _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.status_caps`)), 1),
                      _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.actions_caps`)), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificates, (certificate, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "",
                        key: index
                      }, [
                        _createElementVNode("td", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("a", _hoisted_16, _toDisplayString(_ctx.certificateName(certificate?.certificate_name)), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.scorePercentage(certificate?.certificate_progress)) + "%", 1)
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", {
                                class: "bg-success rounded h-8px",
                                role: "progressbar",
                                style: _normalizeStyle('width: '+ _ctx.scorePercentage(certificate.certificate_progress).toString() + '%'),
                                "aria-valuenow": _ctx.scorePercentage(certificate.certificate_progress),
                                "aria-valuemin": "0",
                                "aria-valuemax": "100"
                              }, null, 12, _hoisted_21)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_22, [
                          _createElementVNode("span", {
                            class: _normalizeClass([_ctx.checkInProgress(certificate.certificate_status).color, "badge py-2 px-4 fs-7"])
                          }, _toDisplayString(_ctx.checkInProgress(certificate?.certificate_status).text), 3)
                        ]),
                        (_ctx.certificateStatus(certificate?.certificate_status))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_23, [
                              _createElementVNode("span", {
                                onClick: ($event: any) => (_ctx.regenerateCertificate(certificate, index)),
                                class: _normalizeClass(["btn btn-sm btn-icon btn-secondary w-30px h-30px", {'disabled': certificate.loading}]),
                                title: "Regenerate Certificate"
                              }, _hoisted_26, 10, _hoisted_24),
                              _createElementVNode("span", {
                                onClick: ($event: any) => (_ctx.copyToClipboard(certificate.certificate_validation_id, index)),
                                class: "btn btn-sm btn-icon btn-secondary w-30px h-30px ms-1"
                              }, [
                                (_ctx.checkCopy[index])
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_28))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_29))
                              ], 8, _hoisted_27),
                              _createElementVNode("a", {
                                href: certificate.certificate_url,
                                target: "_blank",
                                class: "btn btn-sm btn-icon btn-secondary w-30px h-30px mx-1"
                              }, _hoisted_32, 8, _hoisted_30),
                              _createElementVNode("span", {
                                onClick: ($event: any) => (_ctx.sharedLinkedin(certificate.certificate_validation_id)),
                                class: "btn btn-sm btn-icon btn-secondary w-30px h-30px"
                              }, _hoisted_35, 8, _hoisted_33)
                            ]))
                          : (_openBlock(), _createElementBlock("td", _hoisted_36, _hoisted_40))
                      ]))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createElementVNode("span", _hoisted_44, "    " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.in_progress`)) + "... ", 1)
                  ])
                ]))
          ])
        ])
      ])
    ])
  ], 64))
}